module.exports = __webpack_public_path__ + "img/pic_map_shopAoLong.db030bdc.png";